import { validateContentSearch } from "../features/content/search";
import { createFileRoute } from "@tanstack/react-router";
import { ProtectedPage } from "../app/route-boundaries";
import { AdminAppArticlesRoute } from "../pages/AdminAppContentRoutes";
export const Route = createFileRoute("/app/content/articles")({ validateSearch: validateContentSearch, component: () => <ProtectedPage><AdminAppArticlesRoute /></ProtectedPage> });
